<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <div
        @click="onClick"
        class="pa-1"
        style="cursor: pointer;"
        v-on="on"
      >
        <v-row no-gutters align="start">
          <v-col cols="auto" class="pr-2">
            <v-icon large color="grey">mdi-account-circle</v-icon>
          </v-col>
          <v-col>
            <v-row no-gutters align="center">
              <span class="text-body-2 font-weight-medium">{{ version.autor }}</span>
              <v-spacer></v-spacer>
              <v-icon small color="primary">mdi-file</v-icon>
              <span class="ml-1 font-weight-bold text-body-2">{{ version.versionNumber }}</span>
              <span class="ml-2 text-caption grey--text">{{ version.date }}</span>
            </v-row>

            <v-row no-gutters>
              <v-col>
                <span class="text-body-2">{{ version.text }}</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-divider class="my-1" />
      </div>
    </template>
    <span>{{ $t('SelectItem') }}</span>
  </v-tooltip>
</template>

<script>
export default {
    props: {
        version: {
            type: Object
        }
    },
    methods: {
        onClick() {
            this.$emit('on-click', this.version.documentId);
        }
    }
};
</script>